export const GOOGLE_CLIENT_URL = 'https://accounts.google.com/gsi/client';
